/**
 *
 * ui_modalCloneClick.js
 *
 *
 */
(() => {


	/**************************************************************
	 * loopslider内のクローンに対しての処理
	**************************************************************/
	document.addEventListener('click', function(e){
		const button = e.target.closest('.js-modal-img');
		if ( !button ){ return; }

		if ( !button.closest('.is-clone') ){ return; }

		const loop = button.closest('.js-loopslider');
		if ( loop && loop.classList.contains('is-dragging') ){ return; }

		e.preventDefault();
		e.stopPropagation();

		const modalId = button.dataset.modalId;
		const modalSrc = button.dataset.modal;

		let original = null;

		if ( modalId ){
			const list = document.querySelectorAll('.js-modal-img[data-modal-id]');
			for ( let i = 0; i < list.length; i++ ){
				if ( list[i].dataset.modalId === modalId && !list[i].closest('.is-clone') ){
					original = list[i];
					break;
				}
			}
		}

		if ( !original && modalSrc ){
			const list = document.querySelectorAll('.js-modal-img[data-modal]');
			for ( let i = 0; i < list.length; i++ ){
				if ( list[i].dataset.modal === modalSrc && !list[i].closest('.is-clone') ){
					original = list[i];
					break;
				}
			}
		}

		if ( original ){
			original.click();
		}
	}, true);







})();
